module.exports = __webpack_public_path__ + "img/hero-shape-mobile.efd93474.svg";